"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Table = _interopRequireDefault(require("../../preact-components/table/Table"));

var _Loader = require("./Loader");

var _EmptyTable = _interopRequireDefault(require("./EmptyTable"));

var _EmptyResults = require("./EmptyResults");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PopularCategoriesTable = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PopularCategoriesTable, _Component);

  var _super = _createSuper(PopularCategoriesTable);

  function PopularCategoriesTable() {
    var _this;

    (0, _classCallCheck2.default)(this, PopularCategoriesTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      popularCategories: [],
      sorting: {
        order: 'views',
        direction: 'desc'
      },
      isLoading: true
    });
    return _this;
  }

  (0, _createClass2.default)(PopularCategoriesTable, [{
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(prevProps) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.props.startDate !== prevProps.startDate || this.props.endDate !== prevProps.endDate || this.props.selectedRoles !== prevProps.selectedRoles || this.props.selectedContentTypes !== prevProps.selectedContentTypes || this.props.selectedCategories !== prevProps.selectedCategories)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.fetchPopularTopics(this.state.sorting);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "fetchPopularTopics",
    value: function () {
      var _fetchPopularTopics = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(sorting) {
        var res;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  isLoading: true,
                  sorting: sorting
                });
                _context2.prev = 1;
                _context2.next = 4;
                return this.props.fetchData('/analyticsV2/fetchPopularCategories', {
                  sortOrder: sorting.order,
                  sortDirection: sorting.direction
                });

              case 4:
                res = _context2.sent;
                this.setState({
                  popularCategories: res.data,
                  isLoading: false
                });

              case 6:
                _context2.prev = 6;
                this.setState({
                  isLoading: false
                });
                return _context2.finish(6);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1,, 6, 9]]);
      }));

      function fetchPopularTopics(_x2) {
        return _fetchPopularTopics.apply(this, arguments);
      }

      return fetchPopularTopics;
    }()
  }, {
    key: "getModel",
    value: function getModel() {
      return [{
        header: 'Published in',
        accessor: 'category_name',
        size: 'm'
      }, {
        header: 'Views',
        accessor: 'views',
        size: 'xs-right',
        sorting: 'views'
      }, {
        header: 'Posts',
        accessor: 'posts',
        size: 'xs-right',
        sorting: 'posts'
      }, {
        header: 'Topics',
        accessor: 'topics',
        size: 'xs-right',
        sorting: 'topics'
      }, {
        header: 'Replies',
        accessor: 'replies',
        size: 'xs-right',
        sorting: 'replies'
      }, {
        header: 'Likes',
        accessor: 'likes',
        size: 'xs-right',
        sorting: 'likes'
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          popularCategories = _this$state.popularCategories,
          sorting = _this$state.sorting,
          isLoading = _this$state.isLoading;
      var table = (0, _preact.h)(_EmptyTable.default, {
        model: this.getModel()
      }, (0, _preact.h)(_Loader.Loader, {
        parentCustomClass: "dashboard-table-loader"
      }));

      if (!isLoading) {
        table = popularCategories.length > 0 ? (0, _preact.h)(_Table.default, {
          model: this.getModel(),
          rows: popularCategories,
          classes: ['popular_categories__table'],
          onSortChange: function onSortChange(attr) {
            if (attr === sorting.order) {
              return;
            }

            var newSorting = {
              order: attr,
              direction: 'desc'
            };

            _this2.fetchPopularTopics(newSorting);
          },
          sort: sorting,
          "data-element-name": "Popular topics table sort button",
          "data-track-type": "click"
        }) : (0, _preact.h)(_EmptyTable.default, {
          model: this.getModel()
        }, (0, _preact.h)(_EmptyResults.EmptyResults, null));
      }

      return (0, _preact.h)("div", {
        className: "dashboard-table-wrapper"
      }, table);
    }
  }]);
  return PopularCategoriesTable;
}(_preact.Component);

var _default = PopularCategoriesTable;
exports.default = _default;